import React, { useState } from 'react';
import './i18n';  //// import i18n (needs to be bundled ;)) 
import { useTranslation } from 'react-i18next';


import OpenCloseIndicator from './open-close-indicator';
import InputDateRange from './input-date-range-2';


export default function CriteriaDateRange({className, validationEerror, 
        checkInDate, checkOutDate,  menuIsOpen = false, onChange, onDateSelected}) {

    console.log(`CriteriaDateRange(): Entry: ${JSON.stringify({checkInDate, checkOutDate})}`);

    const { t, i18n } = useTranslation();
    const [ startDate, setStartDate] = useState(checkInDate);
    const [ endDate, setEndDate] = useState(checkOutDate);
    const [_menuIsOpen, setMenuIsOpen] = useState(menuIsOpen);


    const handleChange = (ranges) => {
        setStartDate(ranges.selection.startDate);
        setEndDate(ranges.selection.endDate);
    };

    const handleHeaderClick = () => {
        setMenuIsOpen(!_menuIsOpen);
    }

    const formatDate = (date) => {
        if (!date) 
            return ''; // handle null/undefined

        const d = new Date(date); // ensure it's a Date object

        if (isNaN(d.getTime())) {
            console.warn('formatDate(): Invalid date', date);
            return '';
        }
        let locale = i18n.language;
        const effectiveLocale = locale === 'en' ? 'en-GB' : locale;
        const formaattedDate = (new Intl.DateTimeFormat(effectiveLocale, {
            dateStyle: 'short',  // Can be 'full', 'long', 'medium', or 'short'
            //timeStyle: 'short', // Optional for including time, e.g., 'short', 'long', etc.
        })).format(d);
        
        //console.log('CriteriaDateRange::formatDate(): locale=', locale, 'formattedDate=', formaattedDate);
        return formaattedDate;
    };

    const displayDate = (date, defaultValue = '') => {
        //console.log('CriteriaDateRange::displayDate(): date=', date, 'defaultValue=', defaultValue);
        return date ? formatDate(date) : defaultValue;
    }

    const handleDateChange = (startDate, endDate) => {
        setStartDate(startDate);
        setEndDate(endDate);
        if (onChange) {
            onChange({checkInDate: startDate, checkOutDate: endDate});
        }
    }
    
    const hadleDateSelected = () => {
        /*setMenuIsOpen(false);*/ /* hanlde by separate click */
    }
    
    const handleSetDatesClick = (startDate, endDate) => {
        /* just close drop down. rest alreadt changed */            
        console.log(`CriteriaDateRange.handleSetDatesClick(): startDate: ${startDate}, endDate: ${endDate}`);
        if (onDateSelected) {
            onDateSelected(startDate, endDate);
        }
        setMenuIsOpen(false);
    }


    return (
        <div className={`${className} criteria-date-range ${validationEerror ? 'error' : ''}`}>
            <div className={`criteria-date-range-header ${className}-header ${_menuIsOpen?"active":""} header`} 
                    onClick={handleHeaderClick} >

                <span className='label'>{t('Check-in')}:</span>
                <span className='value'>{displayDate(startDate)}</span>
                <span className='label'>{t('Check-out')}:</span>
                <span className='value'>{displayDate(endDate)}</span>

                <span>
                    <OpenCloseIndicator isOpen={_menuIsOpen}/>
                </span>
            </div>

            {_menuIsOpen && ( 
                <>
                    <InputDateRange className={className} 
                        onChange={handleDateChange} 
                        onDateSelected={hadleDateSelected} 
                        onSetDatesClick={handleSetDatesClick}
                    />
                </>
            )}

        </div>
    );
}
